import { Stack } from "@mui/material";
import { TimelineStepItem } from "Components/Shared/VerticalTimeline/TimelineStepItem";
import type { TimelineStep } from "Components/Shared/VerticalTimeline/types";

type Props = {
  steps: ReadonlyArray<TimelineStep>;
  inactiveColor?: string;
};

export const VerticalTimeline = ({ steps, inactiveColor }: Props) => (
  <Stack position="relative">
    {steps.map((step, index) => (
      <TimelineStepItem
        key={step.id}
        step={step}
        isLastStep={index === steps.length - 1}
        inactiveColor={inactiveColor}
      />
    ))}
  </Stack>
);
